export const LINK_MANIFEST_HEAD_SELECTOR = 'link#manifest-placeholder';
export const LINK_REL_APPLE_ICON = "apple-touch-icon";